import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Navbar";
import Privacy from "./Pages/Privacy";
import Terms from "./Pages/Terms";
import AuthMobilePage from "./Pages/AuthMobilePage";

const App = () => {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        {/* <Route path="" element={<WelcomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/account/:userUID" element={<Account />} />
        <Route path="/register-restaurant" element={<AddRestaurantPage />} /> */}
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/auth-mobile" element={<AuthMobilePage />} />
        {/* Add more routes as needed */}
      </Routes>
      <div className="app-container">
        <div className="hero-section">
          <div className="hero-card">
            <div className="hero-header">
              <h1 className="hero-title">TasteBuds</h1>
              <p className="hero-tagline">
                Real Reviews. Real Food. Real People.
              </p>
            </div>

            <p className="hero-description">
              See what people are actually eating, read honest feedback, and
              discover places worth trying near you.
            </p>

            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">⭐</div>
                <h3>Honest Reviews</h3>
                <p>No paid placements, just authentic community feedback</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📸</div>
                <h3>Real Photos</h3>
                <p>See what dishes actually look like before you order</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📍</div>
                <h3>Near You</h3>
                <p>Discover amazing restaurants and dishes in your area</p>
              </div>
            </div>

            <p className="hero-footer">
              TasteBuds is a community review app where users share ratings,
              photos, and quick notes to help everyone decide where to eat.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
